// extracted by mini-css-extract-plugin
export default {"param":"agriculture-parameters-list_param__SBpLQ","param__name":"agriculture-parameters-list_param__name__AcSPs","param__value":"agriculture-parameters-list_param__value__Ma_Nr"};